import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import { Flex } from "../../layout/reusables"
import { Heading, HeadlineText } from "../../styles/typography"
import { _sluggedName } from "../../../utils/utils"
import { colors } from "../../styles/colors"
import placeholder from '../../images/logo-placeholder.png'

export default function ArticlePreviewItem({ item, inverse, index, name }) {

    const excerpt = item.blocks.filter(block => block.type === "paragraph")
    const big = inverse ? index === 0 : index === 2

    return (
        <Link style={{textDecoration: 'none'}} to={(`/${name}/article/${_sluggedName(item.title)}-${item.id}`)}>
            <Container big={big}>
                <CoverImage src={item.headerImage ?? placeholder} />
                <Title>{item.title}</Title>
                {excerpt[0] && <Description dangerouslySetInnerHTML={{__html: excerpt[0]?.data?.text.substr(0, 140) + '...'}} />}
            </Container>
    
        </Link>
    )
}

const Container = styled.div`
    display: grid;
    color: black;
    grid-template-rows: 350px auto auto;
    gap: 12px;
    border-radius: 2px;
    text-decoration: none;
    transition: 0.2s ease;
    cursor: pointer;
    z-index: 3;

    grid-row: ${props => props.big && "1 / span 2"};
    grid-column: ${props =>
        props.big && (props.inverse ? "1 / span 2" : "3 / span 2")};

    @media (max-width: 768px) {
        grid-column: auto;
        grid-row: auto;
    }

    @media (max-width: 550px) {
        grid-template-rows: 300px auto auto;
        grid-column: auto;
        grid-row: auto;
    }
`
const CoverImage = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 4px;
    object-fit: cover;
`
const Title = styled(HeadlineText)`
    font-size: 24px;
    margin-bottom: 0;
    text-decoration: none;
    line-height: 1.3;
    transition: 0.2s ease;
    font-weight: 700;

    ${Container}:hover & {
        color: ${colors.blue};
    }
`

const Description = styled.div`
    font-size: 16px;
    line-height: 1.4;
    transition: 0.2s ease;

    ${Container}:hover & {
        opacity: 0.6;

    }
`